import { FaInstagram } from "react-icons/fa";

const SOCIAL_LABELS = {
	telegram: "تلگرام",
	instagram: "اینستاگرام",
	eitaa: "ایتا",
	bale: "بله",
	rubika: "روبیکا",
};

const socialMediaIcons = [
	{
		name: "telegram",
		path: "/social_media/icon_telegram.png",
		url: "https://t.me/doctoreteem",
	},
	{
		name: "instagram",
		url: "https://www.instagram.com/doctoreteem/",
		useReactIcon: true,
	},
	{
		name: "eitaa",
		path: "/social_media/icon_eitaa.png",
		url: "https://eitaa.com/doctoreteam",
	},
	{
		name: "bale",
		path: "/social_media/icon_bale.png",
		url: "https://ble.ir/doctoreteam",
	},
	{
		name: "rubika",
		path: "/social_media/icon_rubika.png",
		url: "https://rubika.ir/doctoreteam",
	},
];

export default function Social() {
	return (
		<div className="font-Vazir-400 text-[16px] text-darkBlue w-full">
			<div className="text-center text-[#64748B] text-[14px]">
				ما را در شبکه‌های اجتماعی دنبال کنید
			</div>
			<div className="spacer p-[8px]" />
			<div className="flex flex-row flex-wrap items-center justify-center gap-4">
				{socialMediaIcons.map((icon) => {
					const label = SOCIAL_LABELS[icon.name] || icon.name;
					const aria = `${label} همراهتیم`;

					const visual = icon.useReactIcon ? (
						<FaInstagram
							className="w-[32px] h-[32px] text-[#E1306C]"
							aria-hidden
						/>
					) : (
						<img
							src={icon.path}
							alt=""
							className="w-[32px] h-[32px]"
							aria-hidden
						/>
					);

					return (
						<a
							key={icon.name}
							href={icon.url}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={aria}
							className="inline-flex"
						>
							{visual}
						</a>
					);
				})}
			</div>
		</div>
	);
}
